import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const navItems = [
  { label: "CONCEPT", href: "#concept" },
  { label: "SYSTEM", href: "#system" },
  { label: "MENU", href: "#menu" },
  { label: "Q&A", href: "#qa" },
  { label: "ACCESS", href: "#access" },
  { label: "COMPANY", href: "#company" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-white shadow-md"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-[1000px] mx-auto px-6">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-3"
            >
              <img
                src="https://static.readdy.ai/image/3c1a6ae95f0e375c290cace2b2bb289a/ebd5889aa717ac1188561408790e0178.png"
                alt="BAR bebé"
                className="h-10 md:h-12 w-auto object-contain"
              />
            </a>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-8 lg:gap-10">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(item.href);
                  }}
                  className={`text-xs lg:text-sm font-sans font-medium tracking-extra-wide hover:text-amber-500 transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? "text-warm-800" : "text-white/80"}`}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="https://www.instagram.com/barbebe_0515?igsh=eTQyZXByYmJoYndh"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-pink-500 to-orange-400 text-white text-xs font-sans font-medium hover:opacity-90 transition-opacity duration-300 whitespace-nowrap"
              >
                <i className="ri-instagram-line text-sm" />
                Instagram をフォロー
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? "text-warm-800" : "text-white"}`}
              aria-label="メニュー"
            >
              <div className="w-6 flex flex-col gap-1.5">
                <span
                  className={`block h-0.5 transition-transform duration-300 ${scrolled ? "bg-black" : "bg-white"} ${mobileOpen ? "rotate-45 translate-y-2" : ""}`}
                />
                <span
                  className={`block h-0.5 transition-opacity duration-300 ${scrolled ? "bg-black" : "bg-white"} ${mobileOpen ? "opacity-0" : ""}`}
                />
                <span
                  className={`block h-0.5 transition-transform duration-300 ${scrolled ? "bg-black" : "bg-white"} ${mobileOpen ? "-rotate-45 -translate-y-2" : ""}`}
                />
              </div>
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu Panel */}
      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-40 bg-white pt-20 md:hidden"
          >
            <div className="flex flex-col items-center gap-8 pt-8">
              {navItems.map((item, i) => (
                <motion.a
                  key={item.href}
                  href={item.href}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.1 }}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(item.href);
                  }}
                  className="text-lg font-sans font-medium tracking-extra-wide text-warm-800 hover:text-amber-500 transition-colors duration-300 cursor-pointer"
                >
                  {item.label}
                </motion.a>
              ))}
              <motion.a
                href="https://www.instagram.com/barbebe_0515?igsh=eTQyZXByYmJoYndh"
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: navItems.length * 0.1 }}
                className="flex items-center gap-2 text-lg font-sans font-medium tracking-extra-wide text-pink-400 hover:text-pink-300 transition-colors duration-300"
              >
                <i className="ri-instagram-line text-xl" />
                INSTAGRAM
              </motion.a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}